/**
 * 商业信息管理api
 */
import { createAPI } from '../http'
import axios from "axios";
import { API_SVC_HOST } from '../../config/common';
axios.create({
    baseURL: API_SVC_HOST
});
const api = createAPI();
export function getBusinessProductsList(params) {
    /***
     * 商业信息列表
     */
    return api.get('/api/database_business', params)
}

export function deleteBusinessProducts(id) {
    /***
     * 删除商业信息
     * @param {string} id
     */
    return api.delete(`/api/database_business/${id}`)
}

export function getBusinessProductsDetail(id) {
      /***
     * 查询商业信息
     * @param {string} id
     */
    return api.get(`/api/database_business/${id}`)
}

export function putBusinessProducts(id, params) {
    /**
     * 审核产品
     * @param {string} id
     * @param {object} params
     */
    return api.put(`/api/database_business_review/${id}`, params)
}
export function database_business_review(id, params) {
    /**
     * 获取审核信息
     * @param {string} id
     * @param {object} params
     */
    return api.get(`/api/database_business_review/${id}`, params)
}


export function database_eu_registry(params) {
    /**
     * 获取eu注册信息
     * @param {string} id
     * @param {object} params
     */
    return api.post(`/api/database_business_Registry`, params)
}